import {ContainerFacade} from '@igp/shared/ioc-container';
import type {IDownloadStrategy} from '@igp/shared/redux/download';
import type {IEntityReadService} from '@igp/shared/redux/entity';
import type {EntityType} from '@models';

import {PlayerEcologyWeeklyServiceTypes} from './constants';
import {PlayerEcologyWeeklyDownloadServerStrategy} from './downloadStrategy';
import {PlayerEcologyWeeklyService} from './service';
import type {PlayerEcologyWeeklyViewModelKeys} from './types';

export class PlayerEcologyWeeklyContainerFacade extends ContainerFacade {
    bindAll() {
        this._container.bind<IEntityReadService<EntityType>>(PlayerEcologyWeeklyServiceTypes.service).to(PlayerEcologyWeeklyService);
        this._container
            .bind<IDownloadStrategy<PlayerEcologyWeeklyViewModelKeys>>(PlayerEcologyWeeklyServiceTypes.downloadServerStrategy)
            .to(PlayerEcologyWeeklyDownloadServerStrategy);
    }
}
